import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { createNgReactBridgeDirective } from '../../react-bridge'
import { SingleSelectComboboxObject } from '../../../legacy-design-system/combobox'
import { theme } from '@contrast-security-inc/design-system-foundations'

interface OrganizationRole {
  readonly name: string
  readonly group_id: number
}

enum Roles {
  view = 'View',
  edit = 'Edit',
  rules_admin = 'Rules Admin',
  admin = 'Admin',
  org_auditor = 'Auditor'
}

const itemToString = (role: OrganizationRole) => Roles[role.name]

const itemToId = (role: OrganizationRole) => role.group_id

const getRoleByGroupId = (roles: OrganizationRole[], groupId: number) =>
  roles.find((role) => role.group_id === groupId)

function ReactOrganizationRoleCombobox(props) {
  const { footerMessageId, labelId, placeholderId, roles, value } = props

  const initialValue = getRoleByGroupId(roles, value)

  return (
    <FormattedMessage id={labelId}>
      {(label) => (
        <FormattedMessage id={placeholderId}>
          {(placeholder) => (
            <SingleSelectComboboxObject<OrganizationRole>
              {...props}
              items={[{ items: roles }]}
              label={label as React.ReactNode}
              placeholder={placeholder}
              itemToString={itemToString}
              itemToID={itemToId}
              value={initialValue}
              renderFooter={
                !!footerMessageId &&
                (() => {
                  return (
                    <div
                      className={css`
                        background-color: ${theme.color.neutral10};
                        padding: 1em 1.25em 1.25em 1.25em;
                        border-top: 1px solid ${theme.color.neutral20};
                      `}
                    >
                      <FormattedMessage
                        id={footerMessageId}
                        values={{
                          link: (
                            <a
                              href="https://www.contrastsecurity.com/upgrade"
                              target="_blank"
                            >
                              <FormattedMessage id="detail_wizardStepDownload_upgradeToEnterprise" />
                            </a>
                          )
                        }}
                      />
                    </div>
                  )
                })
              }
            />
          )}
        </FormattedMessage>
      )}
    </FormattedMessage>
  )
}

export const reactOrganizationRoleCombobox = createNgReactBridgeDirective(
  'reactOrganizationRoleCombobox',
  [],
  ReactOrganizationRoleCombobox,
  [
    'roles',
    'selectedItem',
    'onChange',
    'value',
    'labelId',
    'placeholderId',
    'footerMessageId'
  ]
)
